import React, { FC, useState } from 'react';
import { IssueDetailContactUsForm } from './IssueDetailContactUsForm';
import { useIssueDetailDataQuery } from '../../hooks';
import { Typography } from '../../../../../components/Typography';
import { useTranslationAPI } from '../../../../translations';
import { issueModuleCodes } from '../../../../../data/translations/issueModuleCodes';
import { PaddingBox } from '../../../../../components/PaddingBox';
import { FormSubmitHandler } from 'redux-form';
import { ContactUsFormValues } from '../../types';
import { usePostIssueDetailMutation } from '../../hooks/usePostIssueDetailMutation';
import { isUndefined } from '../../../../../predicates/type';
import { isBadOrEmptyString } from '../../../../../predicates/string';
import { IssueDetailContactUsMessage } from './IssueDetailContactUsMessage';
import { catchErrorResponse } from '../../../../app';
import { useReCaptchaV3 } from '@packages/reCaptcha/useReCaptchaV3';

export const IssueDetailContactUs: FC = () => {
	const { translate } = useTranslationAPI();
	const { data } = useIssueDetailDataQuery();
	const [responseMessage, setResponseMessage] = useState<string>();
	const [postIssueDetailMutation] = usePostIssueDetailMutation();

	const execute = useReCaptchaV3(data.isAuthenticated === false);

	const handleFormSubmit: FormSubmitHandler<ContactUsFormValues> = async (formValues) => {
		const recaptchaResponse = await execute();

		return postIssueDetailMutation({ ...formValues, recaptchaResponse })
			.then((data) => {
				setResponseMessage(data.message);
			})
			.catch(catchErrorResponse);
	};

	const hasResponseMessage = !isBadOrEmptyString(responseMessage) && !isUndefined(responseMessage);

	return (
		<>
			<PaddingBox bottomMedium>
				<Typography
					headingSize={1}
					bold
					fontSize='20px'
				>
					{translate(issueModuleCodes.contactUs)}
				</Typography>
			</PaddingBox>
			{!hasResponseMessage && (
				<IssueDetailContactUsForm
					onSubmit={handleFormSubmit}
					initialValues={data.form.values}
				/>
			)}
			{hasResponseMessage && <IssueDetailContactUsMessage message={responseMessage} />}
		</>
	);
};
